import { ReactNode } from "react";

interface WrapListProps<T> {
  items: T[];
  children: (item: T) => ReactNode;
}

function WrapList<T>({ items, children }: WrapListProps<T>) {
  return (
    <div className="flex flex-col gap-2 md:flex-row md:flex-wrap">
      {items.map((item, i) => (
        <div key={`wrap-list-item-${i}`}>
            {children(item)}
        </div>
      ))}
    </div>
  );
}

export default WrapList;
